export const REGEX = {
  ANY_ALPHANUMERIC: /[^A-Za-z0-9\uFF10-\uFF19\uFF21-\uFF3A\uFF41-\uFF5A]/gi,
  FULL_WIDTH_HALF_WIDTH_ALPHANUMERIC: /[\uFF10-\uFF19\uFF21-\uFF3A\uFF41-\uFF5A]/g,
};

export const changeToAlphanumeric = (input: string): string => {
  return input.replace(REGEX.FULL_WIDTH_HALF_WIDTH_ALPHANUMERIC, (char) => {
    // Subtract 0xFEE0 from the full-width character code to get its half-width equivalent
    return String.fromCharCode(char.charCodeAt(0) - 0xfee0);
  });
};

export const formatString = (inputValue: string, maxLength: number, validationRule?: RegExp): string => {
  inputValue.replace(REGEX.ANY_ALPHANUMERIC, '');
  const newValue = validationRule ? inputValue.replace(validationRule, '') : inputValue;
  return newValue.slice(0, maxLength);
};

export const equalsIgnoreCase = (str1: string | null, str2: string | null): boolean => {
  // Check if either string is null
  if (str1 === null || str2 === null) {
    return false; // Return false if either is null
  }

  // Check if both strings are the same or if one of them is null or undefined
  if (str1 === str2) {
    return true;
  }

  // Convert both strings to lower case and compare
  return str1.toLowerCase() === str2.toLowerCase();
};

const patterns = {
  forms: /\/forms$/,
  cmxDocuments: /\/cmx\/documents\/[a-zA-Z0-9-]*\/files$/,
  documentsAction: /\/session\/[0-9-]*\/documents\/[0-9-]*\/files$/,
};
export const isNoLoaderUrl = (url: string) => {
  return patterns.forms.test(url) || patterns.cmxDocuments.test(url) || patterns.documentsAction.test(url);
};
